"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const minifyGraphQLQuery = (query) => {
  return query.replace(/(\n| )*( |{|})(\n| )*/gm, (_chars, _spaces, brackets) => brackets);
};
exports.minifyGraphQLQuery = minifyGraphQLQuery;
//# sourceMappingURL=minifyGraphQLQuery.cjs.map
